module.exports = __webpack_public_path__ + "static/fonts/Montserrat900italic.59a08c76.ttf";